import { useState } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import styles from './add-note-input.module.css'
import Button from '@mui/material/Button'
import { NoteType } from '../../../../../../../app/types/order-notes'

interface AddNoteInputProps {
  onSubmit: (type: NoteType, content: string) => Promise<void>
  isReadOnly?: boolean
  isSubmitting?: boolean
}

export default function AddNoteInput({
  onSubmit,
  isReadOnly = false,
  isSubmitting = false,
}: AddNoteInputProps) {
  const [noteType, setNoteType] = useState<NoteType | null>(null)
  const [content, setContent] = useState('')

  async function handleSubmit() {
    if (!content.trim() || isSubmitting || isReadOnly || !noteType) return
    await onSubmit(noteType, content.trim())
    setContent('')
    setNoteType(null)
  }

  const isDisabled = isReadOnly || isSubmitting || !content.trim() || !noteType

  return (
    <div className={styles.container}>
      <textarea
        className={styles.textArea}
        placeholder='Add a note...'
        value={content}
        onChange={(e) => setContent(e.target.value)}
        disabled={isReadOnly}
        rows={2}
      />
      <div className={styles.bottomRow}>
        <TextField
          select
          size='small'
          value={noteType || ''}
          label='Type'
          onChange={(e) => setNoteType(e.target.value as NoteType)}
          disabled={isReadOnly}
          className={styles.typeSelect}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: { maxHeight: 200 },
              },
            },
          }}
        >
          <MenuItem value='technician_note'>Technician Note</MenuItem>
          <MenuItem value='activity_log'>Activity Log</MenuItem>
        </TextField>
        <Button
          onClick={handleSubmit}
          variant='outlined'
          style={{ textTransform: 'none' }}
          sx={{
            color: isDisabled ? '#767676' : '#d70000',
            borderColor: isDisabled ? '#c2c2c2' : '#d70000',
            backgroundColor: isDisabled ? '#efefef' : '#ffffff',
            flex: 1,
            fontWeight: 600,
            fontSize: '14px',
          }}
          className={styles.addButton}
          disabled={isDisabled}
        >
          {'Add'}
        </Button>
      </div>
    </div>
  )
}
